import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useUnmarkPlaybookAsFavorite = () => {
  const { call, isLoading } = useApiPrivateRequest();

  const unmarkPlaybookAsFavorite = async (id: string) => {
    await call(`/playbooks/${id}/favorite`, "DELETE");
  };

  return {
    unmarkPlaybookAsFavorite,
    isLoading,
  };
};
